import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CaseType } from '../../../pipes/case.pipe';

@Component({
  selector: 'app-base-field',
  imports: [CommonModule],
  template: ``,
  styles: ``,
})
export class BaseFieldComponent {
  @Input()
  label: string;

  @Input()
  controlLabel: string;

  @Input()
  control: FormControl<any>;

  @Input()
  labelClasses: string;

  @Input()
  valueClasses: string;

  @Input()
  helpText: string;

  @Input()
  showHelpText = true;

  @Input()
  placeholder = '';

  @Input()
  labelCase: CaseType = 'sentence';

  get required(): boolean {
    return this.control.hasValidator(Validators.required);
  }
}
